"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAllFilesValid = exports.formatBytes = void 0;
const formatBytes = bytes => {
  if (!bytes || bytes === 0) return '0 KB';
  const k = 1000;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
exports.formatBytes = formatBytes;
const isAllFilesValid = (files, maxFileSizeInBytes) => {
  // Checks if all files in file array are valid sizes

  const exceeds = files.some(file => file.size > maxFileSizeInBytes);
  return !exceeds;
};
exports.isAllFilesValid = isAllFilesValid;